/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import { IAadGenericViewProps } from './aad-generic';

export default (props: IAadGenericViewProps) => {
    const {
        aadGeneric,
        aadConainer,
        aadAPIConainer,
        heading
    } = props;

    return (
        <Module {...aadGeneric}>
            <Node {...aadConainer}>
                {heading}
                {aadAPIConainer}
            </Node>
        </Module>
    );
};
